var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ds-context-menu-group",
      class: [_vm.positionX, _vm.positionY],
      style: _vm.position,
    },
    [
      _vm._l(_vm.realList, function (menu, index) {
        return [
          menu.divided
            ? _c("div", { key: index, staticClass: "ds-context-menu-divided" })
            : !_vm.contextMenuRoot.isHide(menu)
            ? _c(
                "div",
                {
                  key: index,
                  staticClass: "ds-context-menu-item",
                  class: { disabled: _vm.contextMenuRoot.isDisabled(menu) },
                  on: {
                    mouseenter: function ($event) {
                      return _vm.onMouseenter(menu)
                    },
                    mouseleave: function ($event) {
                      return _vm.onMouseleave(menu)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "ds-context-menu-item-content",
                      class: { "has-icon": _vm.hasIcon },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.contextMenuRoot.itemClick(menu, $event)
                        },
                      },
                    },
                    [
                      menu.icon
                        ? _c("i", {
                            staticClass: "ds-context-menu-item-icon iconfont",
                            class: [menu.icon],
                            style: { color: menu.color },
                          })
                        : _vm._e(),
                      _c("span", { staticClass: "ds-context-menu-item-name" }, [
                        _vm._v(_vm._s(menu.name)),
                      ]),
                    ]
                  ),
                  _c("i", {
                    staticClass: "item-right",
                    class: [
                      menu.loading ? "el-icon-loading" : "iconfont icon-right",
                    ],
                    attrs: { show: menu.$hasChildren },
                  }),
                  menu.$hasChildren && menu.$loaded
                    ? [
                        menu.childrenShow
                          ? _c("dsf-context-menu-group", {
                              attrs: { list: menu._children },
                            })
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }